import React from 'react';

import classNames from 'classnames';
import styled from 'styled-components';

import { CompanyListItemType } from './types';
import { useCompaniesContext } from '../CompaniesContext';

const Container = styled.span`
  display: flex;
  flex-direction: column;
  margin: 2px 0px 10px 0px;
`;

const Count = styled.span`
  font-family: var(--font-regular);
  font-size: 14px;
  color: var(--dark-blue);
  cursor: pointer;
`;

const CompetitorCount = styled.span`
  font-family: var(--font-regular);
  font-size: 12px;
  color: var(--text-secondary);

  &.red {
    color: var(--error-red);
  }
`;

interface Props {
  item: CompanyListItemType;
}

const CompaniesTableCompany = ({ item }: Props) => {
  const { onEnterSupportMode } = useCompaniesContext();
  const showRed =
    item?.competitors_count && item?.community_count && item?.competitors_count > item?.community_count * 5;

  return (
    <Container>
      <Count onClick={() => onEnterSupportMode(item)}>
        {item?.community_count} {item?.community_count === 1 ? 'Community' : 'Communities'}
      </Count>
      <CompetitorCount className={classNames({ red: showRed })}>
        {item?.competitors_count}/{(item?.community_count || 0) * 5} competitors
      </CompetitorCount>
    </Container>
  );
};

export default CompaniesTableCompany;
